import React from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import BaseDialog from '../BaseDialog/BaseDialog';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class DeleteDialog extends React.Component {
  render() {
    const {
      classes,
      theme,
      open,
      cancel,
      subject,
      deleteContact,
      dialogContent,
      dialogContentNoSubject,
    } = this.props;

    const stringsComponent = 'contactDetails';

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          title={getString(stringsComponent, 'DELETE_CONTACT_TITLE')}
          content={
            subject ? (
              <React.Fragment>
                {dialogContent}'{subject}'?
              </React.Fragment>
            ) : (
              dialogContentNoSubject
            )
          }
          buttonAction={deleteContact}
          buttonLabel={getString(stringsComponent, 'DELETE_BUTTON_LABEL')}
          buttonCustomClass={classes.deleteButton}
          secondaryButtonAction={cancel}
          secondaryButtonLabel={getString(
            stringsComponent,
            'CANCEL_BUTTON_LABEL'
          )}
          icon={DeleteIcon}
        />
      </div>
    );
  }
}

DeleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  dialogContent: PropTypes.string.isRequired,
  dialogContentNoSubject: PropTypes.string,
  open: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  subject: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  deleteContact: PropTypes.func,
};

DeleteDialog.defaultProps = {
  open: false,
  dialogContent: '',
  dialogContentNoSubject: '',
};

export default withStyles(styles, { withTheme: true })(DeleteDialog);
